var RequestStore = function () {
  function RequestStore() {}
  RequestStore.get = function (hash) {
    if (RequestStore.has(hash)) {
      return RequestStore.store.get(hash);
    }
  };
  RequestStore.set = function (hash, request) {
    if (!RequestStore.has(hash)) {
      RequestStore.store.set(hash, request);
    }
  };
  RequestStore.has = function (hash) {
    return RequestStore.store.has(hash);
  };
  RequestStore.drop = function (hash) {
    if (RequestStore.has(hash)) {
      RequestStore.store["delete"](hash);
    }
  };
  RequestStore.store = new Map();
  return RequestStore;
}();

export { RequestStore as default };
//# sourceMappingURL=index.js.map
